import { TextField } from "@material-ui/core";
import React from "react";
import QInputProps from "./QInputProps";

export default function QTextShort(p: QInputProps) {
  return <TextField placeholder="Your answer" fullWidth value={p.value || ""} onChange={e => {p.onValueChange(e.target.value || null)}}/>
}